import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=674c081e&scoped=true"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"
import style0 from "./Counter.vue?vue&type=style&index=0&id=674c081e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c081e",
  null
  
)

export default component.exports